/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SnackbarService } from './services/snackbar.service';
import { SafePipe } from './pipes/safe-pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {
    AngularImageViewerModule
} from "angular-x-image-viewer";
import { TitlePipe } from './pipes/title.pipe';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';

/**
 * NgModule that includes all Custom modules that are required to serve the app.
 */
@NgModule({
    exports: [
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        Ng2SearchPipeModule,
        AngularImageViewerModule,
        SafePipe,
        TitlePipe,
        ImageUrlPipe,
        NgMultiSelectDropDownModule,
        NgxSpinnerModule
    ],
    providers: [
        SnackbarService
    ],
    declarations: [
        SafePipe,
        TitlePipe,
        ImageUrlPipe
    ],
})
export class CustomModule { }
